import MsaSection from './MsaSection';
import PolicyIndicatorsSection from './PolicyIndicatorsSection';
import SummaryResultsSection from './SummaryResultsSection';

interface MeanSpeciesAbundanceProps {
  projectId?: string;
}

const MeanSpeciesAbundance = ({ projectId }: MeanSpeciesAbundanceProps) => {
  return (
    <div className="d-flex f-column gap-16" style={{ width: '100%' }}>
      <div 
        className="msa-main-container d-flex gap-16 f-column" 
        style={{ width: '100%' }}
      >
        <div className="msa-main-left">
          <MsaSection projectId={projectId} />
        </div>
        <div className="msa-main-right">
          <PolicyIndicatorsSection projectId={projectId} />
        </div>
      </div>
      
      <div style={{ width: '100%' }}>
        <SummaryResultsSection projectId={projectId} />
      </div>
    </div>
  );
}

export default MeanSpeciesAbundance;